/*
  This function returns a trimmed version of the given string.  The returned string will have whitespace removed from both ends.
*/
export function CA_stringTrim(str) {
    var from = 0;
    var to = str.length - 1;

    while (from < str.length && isWhiteSpace(str.charAt(from)))
        from++;

    while (to > from && isWhiteSpace(str.charAt(to)))
        to--;

    return str.substring(from, to + 1);
}

export function isWhiteSpace(aChar) {
    return aChar === " " || aChar === "\t" || aChar === "\xA0" || aChar === "\n" || aChar === "\r";
}

export function getSuffix(text) {
    if (!text) {
        return "";
    }
    return text.split('.').pop();
}